export default {
  56001: '您已经申请过该能力',
};
